import { DetailsPageSkeleton } from "components/ui";
import { useGetExhibitionByIdQuery } from "graphql/queries/generated/queries";
import { useParams } from "react-router-dom";
import Page from "./Page";

const EditExhibitionPage = () => {
  const { exhibitionId } = useParams();

  const { data, loading, error, refetch } = useGetExhibitionByIdQuery({
    variables: {
      id: exhibitionId,
    },
  });

  if (loading) return <DetailsPageSkeleton loading={loading} />;
  if (!data) return null;

  return <Page data={data} refetchExhibition={refetch} />;
};

export default EditExhibitionPage;
